(function () {
  'use strict';

  angular.module('sempraWebapp').factory('CampaignTemplateEnum', campaignTemplateFactory);

  function campaignTemplateFactory () {
    return Object.freeze({
      NUM_OF_VISITS: 'NUM_OF_VISITS',
      MONEY_SPENT: 'MONEY_SPENT',
      DAILY_TEMPORAL: 'DAILY_TEMPORAL'
    });
  }
})();
